module.exports = __webpack_public_path__ + "static/img/7.6bc17f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/7.png
// module id = o1gk
// module chunks = 0